import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const CartPage = () => {
  const { items, updateQty, removeItem, cartTotal } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="page">
        <div className="empty-cart">
          <div className="icon">🛒</div>
          <h2>Your cart is empty</h2>
          <p>Browse our fresh products and add them to your cart.</p>
          <Link to="/" className="btn btn-green">🛍️ Shop Now</Link>
        </div>
      </div>
    );
  }

  const delivery = 0; // Free delivery
  const tax = cartTotal * 0.05;
  const total = cartTotal + tax + delivery;

  return (
    <div className="page cart-page">
      <h1>🛒 Your Cart</h1>
      <div className="cart-layout">
        {/* Items */}
        <div className="cart-items">
          {items.map(item => (
            <div key={item.id} className="cart-item">
              <div className="cart-item-img">
                {item.image_url ? <img src={item.image_url} alt={item.name} /> : '🥬'}
              </div>
              <div className="cart-item-info">
                <div className="cart-item-name">{item.name}</div>
                <div className="cart-item-price">₹{parseFloat(item.price).toLocaleString('en-IN')} each</div>
                <div className="qty-control" style={{ marginTop: 8, width: 'fit-content' }}>
                  <button className="qty-btn" onClick={() => updateQty(item.id, item.quantity - 1)}>−</button>
                  <span className="qty-value">{item.quantity}</span>
                  <button className="qty-btn" onClick={() => updateQty(item.id, item.quantity + 1)}>+</button>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 10 }}>
                <div className="cart-item-subtotal">₹{(parseFloat(item.price) * item.quantity).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</div>
                <button
                  onClick={() => removeItem(item.id)}
                  style={{ background: '#fee2e2', border: 'none', color: '#b91c1c', borderRadius: 8, padding: '5px 10px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
          <div style={{ marginTop: 8 }}>
            <Link to="/" className="btn btn-light btn-sm">← Continue Shopping</Link>
          </div>
        </div>

        {/* Summary */}
        <div className="cart-summary">
          <div className="summary-title">Order Summary</div>
          <div className="summary-row"><span>Subtotal</span><span>₹{cartTotal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span></div>
          <div className="summary-row"><span>GST (5%)</span><span>₹{tax.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span></div>
          <div className="summary-row"><span>🚚 Delivery</span><span style={{ color: 'var(--green)', fontWeight: 600 }}>FREE</span></div>
          <div className="summary-total">
            <span className="label">Total</span>
            <span className="value">₹{total.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>
          </div>
          <button className="btn btn-green btn-full" style={{ marginTop: 20, padding: '14px' }} onClick={() => navigate('/checkout')}>
            Proceed to Checkout →
          </button>
          <div style={{ textAlign: 'center', marginTop: 14, fontSize: 12, color: 'var(--text-3)' }}>
            🔒 100% Secure · Free delivery on all orders
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
